import type {
	ClientPropertyCottageDetailResponseDTO,
	ClientPropertyFlatDetailResponseDTO,
	ClientPropertyHouseDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { BUILDING_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormDefaults";
import type { BuildingFormInput } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { toSelectedKeys } from "web_myplann/Portfolio/Helpers/booleanGroups";
import { BUILDING_OPTIONAL_PARAMS } from "web_myplann/Portfolio/Helpers/buildingOptionalParams";

type BuildingDetail =
	| ClientPropertyFlatDetailResponseDTO
	| ClientPropertyHouseDetailResponseDTO
	| ClientPropertyCottageDetailResponseDTO;

export const mapPropertyToBuildingForm = (
	property: BuildingDetail,
	numberOfFloors: number | null | undefined,
): BuildingFormInput => ({
	name: property.name ?? DEFAULTS.name,
	location: property.location ?? DEFAULTS.location,
	locationMunicipality:
		property.locationMunicipality ?? DEFAULTS.locationMunicipality,
	locationZipCode: property.locationZipCode ?? DEFAULTS.locationZipCode,
	usableArea: property.usableArea ?? DEFAULTS.usableArea,
	floorArea: property.floorArea ?? DEFAULTS.floorArea,
	householdArea:
		("householdArea" in property ? property.householdArea : null) ??
		DEFAULTS.householdArea,
	landSize:
		("landSize" in property ? property.landSize : null) ?? DEFAULTS.landSize,
	disposition: property.disposition ?? DEFAULTS.disposition,
	buildingMaterial: property.buildingMaterial ?? DEFAULTS.buildingMaterial,
	numberOfFloors: numberOfFloors ?? DEFAULTS.numberOfFloors,
	amenities: toSelectedKeys(BUILDING_OPTIONAL_PARAMS, property),
	marketValue: property.marketValue ?? DEFAULTS.marketValue,
	reproductionValue: property.reproductionValue ?? DEFAULTS.reproductionValue,
	interiorValue: property.interiorValue ?? DEFAULTS.interiorValue,
	purchaseDate: parseIsoDate(property.purchaseDate),
	description: property.description ?? DEFAULTS.description,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
